/**
 * Typed mirror of tokens.css — for places JS needs a value (SVG strokes,
 * chart series, style={{}} leftovers that can't be classes).
 * CSS files remain the source of truth; keep the two in sync (the audit
 * script flags drift by counting raw hex outside this file).
 */
export const tokens = {
  color: {
    navyDeep: '#0a1520',
    navy: '#0d1b2a',
    navyHover: '#162536',
    navyLight: '#1b2d42',
    navyLighter: '#243b53',
    navyMuted: '#a9b7c9',
    amber: '#e8a020',
    amberHover: '#d69010',
    danger: '#f43f5e',
    dangerStrong: '#e11d48',
    success: '#22c55e',
    warning: '#facc15',
    info: '#3b82f6',
    neutral: '#6b7280',
  },
  radius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    full: '9999px',
  },
  z: {
    base: 0,
    sticky: 10,
    drawer: 20,
    modal: 50,
    popover: 100,
    tooltip: 1000,
  },
  text: {
    '2xs': '0.625rem',
    xs: '0.6875rem',
    sm: '0.75rem',
    base: '0.875rem',
    md: '0.9375rem',
    lg: '1rem',
  },
} as const;

/**
 * Canonical status tones — the one map that absorbs RunStatusBadge,
 * IntakeStatusBadge, ExportsScreen StatusPill and ResponseStatusPill.
 * Semantic hues only; geometry lives in StatusPill's variant classes.
 */
export type StatusTone =
  | 'neutral'
  | 'navy'
  | 'running'
  | 'ready'
  | 'failed'
  | 'warning'
  | 'info'
  | 'danger';

export const STATUS_TONE_CLASSES: Record<StatusTone, string> = {
  neutral: 'bg-gray-500/15 text-gray-300 border-gray-500/30',
  navy: 'bg-navy text-gray-400 border-navy-lighter',
  running: 'bg-amber/15 text-amber border-amber/30',
  ready: 'bg-green-500/15 text-green-400 border-green-500/30',
  failed: 'bg-red-500/15 text-red-400 border-red-500/30',
  warning: 'bg-amber/15 text-amber border-amber/30',
  info: 'bg-blue-500/15 text-blue-400 border-blue-500/30',
  danger: 'bg-rose-500/15 text-rose-400 border-rose-500/30',
};
